import { FinancialSummaryInfo } from '../approval/types';
import { formatToThousands } from '../utils/utils';
import { returnCurrencyObject } from '../../hooks/useLocalCurrency';

const returnFormattedForecast = (
  forecast: FinancialSummaryInfo,
  currencyRate,
) => {
  return {
    forecastLandCost: formatToThousands(forecast.landCost * currencyRate),
    forecastPropertyInvestment: formatToThousands(
      forecast.propertyInvestment * currencyRate,
    ),
    forecastRetailInvestment: formatToThousands(
      forecast.retailInvestment * currencyRate,
    ),
    forecastRetailCost: formatToThousands(forecast.retailCost * currencyRate),
    totalForecast: formatToThousands(forecast.totalInvestment * currencyRate),
  };
};

export const mapFinancialSummaryInfos = (project, currencies) => {
  return (
    project.financialSummaryInfos?.[0] &&
    returnFormattedForecast(
      project.financialSummaryInfos?.[0],
      returnCurrencyObject(
        currencies,
        project.countryCode,
        project.financialSummaryInfos?.[0].fiscalYear,
      )?.currencyRate,
    )
  );
};
